import styled from 'styled-components'
import React from 'react'
import { PageCopy } from '../global'
import ArrowRight from '../../svg/arrow-right'

const IntroCopy = ({ handleClick }) => {
  return (
    <>
      <PageCopy>
        <p>
          We specialise in architecturally driven homes, delivering a
          considered and well-managed process from first engagement through to
          handover.
        </p>
        <p>To ensure alignment from the outset:</p>
        <List>
          <li>
            We prefer to be engaged at the design concept stage to provide
            early cost clarity and guide successful outcomes
          </li>
          <li>
            Our focus is on turn-key residential projects, including new
            builds, renovations and full fit-outs
          </li>
          <li>Complete builds are typically in the $3M–$7M range</li>
          <li>Fit-out projects are generally $1M+</li>
          <li>
            Our square metre rates start from $7,500/sqm, subject to scope and
            level of detail
          </li>
          <li>Our clients value design, quality and a fully managed delivery</li>
        </List>
        <p>
          If this sounds like your project, we welcome the opportunity to
          review your plans and/or connect with your architect.
        </p>
      </PageCopy>
      <StyledButton onClick={handleClick}>
        <span>Get started</span>
        <ArrowRight />
      </StyledButton>
    </>
  )
}

export default IntroCopy

const List = styled.ul`
  li {
    list-style: disc;
  }
  padding: 0 0 0 1em;
  margin-bottom: 1.5rem;
`

const StyledButton = styled.button`
  font-weight: normal;
  height: auto;

  border-radius: 0;
  padding: 1rem;
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.pageTheme.fgTertiary};
  background-color: ${({ theme }) => theme.pageTheme.bgTertiary};
  ${({ theme }) => theme.fontSizing(theme.font.buttonSizes)};

  svg {
    width: 1.5rem;
    margin-left: 2rem;
  }
`
